export const Provider = new Map<number, string>([
  [0, 'Unknown'],
  [1, 'Bandwidth'],
  [2, 'Telnyx'],
]);
